import { VStack } from "@chakra-ui/react"
import React from "react"
import { Header } from "../../components"
import { MarkManualUserAttendanceBulkOutForm } from "../../forms"

const MarkAttendanceOutPage: React.FC = () => {
	return (
		<VStack w="full" align="stretch" p="8" spacing={4}>
			<Header title="Mark User Attendance Out" />
			<VStack w="full" align="stretch">
				<VStack w="full" align="stretch" spacing={4}>
					<MarkManualUserAttendanceBulkOutForm />
				</VStack>
			</VStack>
		</VStack>
	)
}

export default MarkAttendanceOutPage
